






















































import DatePickerField from '@/components/fields/DatePickerField.vue';
import FileField from '@/components/fields/FileField.vue';
import { ODDocumentsForm } from '@/model';
import { AgencyDocumentTypeChoices, CompanyDocumentTypeChoices, IUserDocumentsType } from '@homeserve/od-typings/api';
import { Nullable } from '@homeserve/od-typings/utils';
import { Validator } from 'vee-validate';
import { Component, Emit, Inject, Model, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { DatePickerField, FileField },
})
export default class DocumentTypeField extends Vue {
  public get hasValidityEndDate(): boolean {
    return this.isRcp;
  }

  public get hasValidityStartDate(): boolean {
    return this.isKbis || this.isRcp;
  }

  public get isKbis(): boolean {
    return this.type === CompanyDocumentTypeChoices.KBIS;
  }

  public get isRcp(): boolean {
    return this.type === AgencyDocumentTypeChoices.RESPONSABILITE_CIVILE_PROFESSIONNELLE;
  }

  @Inject('$validator')
  public readonly $validator!: Validator;

  @Model('change', { type: Object, required: true })
  public readonly document!: any;

  @Prop({ type: String, required: true })
  public readonly formScope!: string;

  @Prop({ type: String, required: true })
  public readonly type!: IUserDocumentsType;

  @Prop({ type: String, default: 'application/pdf,image/*' })
  public readonly mimeTypes!: string;

  @Prop({ type: Boolean, default: true })
  public rcpNumMandatory!: boolean;

  public getRules(property: 'validityEndDate' | 'validityStartDate') {
    const rules: { [rule: string]: any } = {
      required: true,
    };

    if (!this.isRcp) {
      return rules;
    }

    if (property === 'validityStartDate' && this.document.validityEndDate) {
      rules.date_lesser_than = this.document.validityEndDate;
    } else if (property === 'validityEndDate' && this.document.validityStartDate) {
      rules.date_greater_than = this.document.validityStartDate;
    }

    return rules;
  }

  @Emit('change')
  public resetRcpNum() {
    return {
      ...this.document,
      [AgencyDocumentTypeChoices.RESPONSABILITE_CIVILE_PROFESSIONNELLE]: {
        ...this.document[AgencyDocumentTypeChoices.RESPONSABILITE_CIVILE_PROFESSIONNELLE],
        rcpNum: '',
      },
    };
  }

  @Emit('change')
  public updateFile(file: Nullable<File>): ODDocumentsForm {
    return {
      ...this.document,
      file,
    };
  }
}
